import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useCurrentUser } from "shared/auth/hooks/useCurrentUser";
import { getCookie } from "shared/auth/utils/cookieUtils";

// Styles
import "styles/legacy/mobile-menu.css";

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation(); // Get current route
  const user = useCurrentUser();
  const userFirstName = user?.firstName || "";
  const userLastName = user?.lastName || "";
  const userRole = getCookie("userRole") || "Viewer";
  const [activeItem, setActiveItem] = useState(() => {
    // Set initial active item based on current path
    if (location.pathname === "/mobile/pair_headset") return "pair_headset";
    if (location.pathname === "/mobile/order_history") return "order_history";
    if (location.pathname === "/mobile/profile") return "profile";
    return "menu-item-inactive";
  });

  const handlePair = () => {
    setActiveItem("pair_headset");
    navigate("/mobile/pair_headset");
  };
  const handleProfile = () => {
    setActiveItem("profile");
    navigate("/mobile/profile");
  };
  const handleOrders = () => {
    setActiveItem("order_history");
    navigate("/mobile/order_history");
  };

  return (
    <div className="menu-mobile">
      <div className="top-container-menu-mobile">
        <button className="close-menu-button-profile " onClick={onClose}>
          <img
            src="/images/mobile/mobile_menu_close.svg"
            className="close-menu-icon-mobile"
            alt=""
          />
        </button>
        <div className="menu-items-mobile">
          <ul>
            {userRole === "Creator" && (
              <li
                className={
                  activeItem === "library"
                    ? "menu-item-mobile-active"
                    : "menu-item-mobile-inactive"
                }
              >
                <div className="disabled-btns-menu">
                  <div className="disabled-btns-text-menu">Library</div>
                  <button className="disabled-btns-btn-menu" disabled>
                    Desktop Only
                  </button>
                </div>
              </li>
            )}
            {/* <li TODO: ADD WHEN REQUESTED
              className={
                activeItem === "organization"
                  ? "menu-item-mobile-active"
                  : "menu-item-mobile-inactive"
              }
            >
              <div className="disabled-btns-menu">
                <div className="disabled-btns-text-menu">Organization</div>
                <button className="disabled-btns-btn-menu" disabled>
                  Desktop Only
                </button>
              </div>
            </li> */}
            <li
              className={
                activeItem === "home"
                  ? "menu-item-mobile-active"
                  : "menu-item-mobile-inactive"
              }
              onClick={() => {
                setActiveItem("home");
                navigate("/mobile/home");
                onClose();
              }}
            >
              Home
            </li>
            <li
              className={
                activeItem === "pair_headset"
                  ? "menu-item-mobile-active"
                  : "menu-item-mobile-inactive"
              }
              onClick={handlePair}
            >
              Pair headset
            </li>
            <li
              className={
                activeItem === "order_history"
                  ? "menu-item-mobile-active"
                  : "menu-item-mobile-inactive"
              }
              onClick={handleOrders}
            >
              Order history
            </li>

            <li
              className={
                activeItem === "profile"
                  ? "menu-item-mobile-active"
                  : "menu-item-mobile-inactive"
              }
              onClick={handleProfile}
            >
              Profile
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-menu-mobile">
        <div className="footer-name-menu-mobile">
          <div className="user-icon-container-menu-mobile">
            <div className="user-icon-menu-mobile">
              {userFirstName.charAt(0).toUpperCase()}
              {userLastName.charAt(0).toUpperCase()}
            </div>
          </div>
          <div className="sidebar-user-name">
            {`${userFirstName} ${userLastName}`}
          </div>
        </div>

        <button
          className="logout-button-profile"
          onClick={() => navigate("/logout")}
        >
          <img
            src="/images/icons/logout.svg"
            className="logout-icon-profile"
            alt="Icon"
          />
          <div className="logout-text-profile">Log out</div>
        </button>
      </div>
    </div>
  );
};

export default MobileMenu;
